// Gruntfile.js uses string-replace-loader to replace these values during build time.
export const VERSION = '5.0.0-alpha.4';
export const ID = 'b71510759a0805f5a61170a47ec293256833eb35';
export const DATE = '2024-06-24T05:25:46.334Z';
